module.exports = __webpack_public_path__ + "static/img/shuiBigBd.629fc02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shuiBigBd.jpg
// module id = 6P80
// module chunks = 0